export const LS_KEY='plume.v1';
export const canStore=(()=>{try{localStorage.setItem('__p','1');localStorage.removeItem('__p');return true}catch(e){return false}})();
export const memStore={};
export function rawLoad(){try{const s=canStore?localStorage.getItem(LS_KEY):memStore[LS_KEY];return s?JSON.parse(s):null}catch(e){return null}}
export function rawSave(o){const s=JSON.stringify(o);if(canStore)localStorage.setItem(LS_KEY,s);else memStore[LS_KEY]=s}

export const uid=()=>Date.now().toString(36)+Math.random().toString(36).slice(2,7);
export const STU_COLORS=['#2242C8','#C2472F','#217A52','#8248B8','#B8790E','#1F7E8C','#B33771','#4C5FD5','#5E7A1F','#A04B2E'];

export function defaultTz(){try{return Intl.DateTimeFormat().resolvedOptions().timeZone||'Europe/Berlin'}catch(e){return 'Europe/Berlin'}}
export function defaultState(){
  return {
    v:1,
    settings:{
      lang:(navigator.language||'en').slice(0,2).match(/^(de|fr)$/)?(navigator.language.slice(0,2)):'en',
      theme:'auto', teacher:'', biz:'', addr:'', taxId:'', iban:'', bank:'', paypal:'',
      currency:'EUR', defRate:30, defDur:60, invPrefix:'R-'+new Date().getFullYear()+'-', invNext:1,
      vatOn:false, vatP:19, kleinOn:true, dueDays:14,
      lastBackup:0, dismissed:{},
      tz:defaultTz(), lateCancelH:24, stuRemind:{on:false,hours:24}
    },
    templates:{}, // override map: templates[lang][type] = {s,b}
    students:[], sessions:[], recs:[], invoices:[]
  };
}
export let S=rawLoad()||defaultState();
export function setState(o){S=o}
if(!S.settings.dismissed)S.settings.dismissed={};
if(!S.templates)S.templates={};
S.settings={...defaultState().settings,...S.settings};   // fill keys added in later versions
export function persist(){rawSave(S);if(window.queueCloudSave)window.queueCloudSave()}

/* ---------- dates ---------- */

export function importJSON(obj){
  if(!obj||obj.v!==1||!Array.isArray(obj.students))return false;
  setState(obj);if(!S.settings.dismissed)S.settings.dismissed={};if(!S.templates)S.templates={};
  persist();return true;
}
